import React from 'react';
import { Eyebrow, Section, YouAreHereDot } from './Section';
import { capSteps, coverageChips, offer, revealStats } from '../data/offer';
export function ProductReveal() {
  return <Section tone="creme" labelledBy="produit-title" data-id="element-198" data-mp="361rvbjx5csoi">
      <Eyebrow data-id="element-199" data-mp="361jjzwgo9vff">
        Le système complet pour mener un accompagnement de la Séance Zéro au
        bilan de clôture
      </Eyebrow>

      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-200" data-mp="2dddwx325bucf">
        <div className="lg:col-span-6" data-id="element-201" data-mp="2db9tsnc2mzd7">
          <h2 id="produit-title" className="font-serif text-4xl font-semibold leading-[1.1] text-graphite md:text-[3rem]" data-id="element-202" data-mp="28et5nt4vgl04">
            {offer.name}
          </h2>
          <p className="mt-4 text-sm font-medium uppercase tracking-[0.12em] text-warm" data-id="element-203" data-mp="2ibxj94knj85b">
            6 tomes + 5 bonus — De la Séance Zéro au cap de la quatrième séance,
            jusqu’au bilan de clôture
          </p>
          <p className="mt-8 max-w-prose text-base leading-relaxed text-graphite-mid md:text-lg" data-id="element-204" data-mp="1pmqn2c8o6un8">
            Ce n’est pas une formation de plus. Ce n’est pas une boîte à outils
            de 400 fiches. Ce n’est pas une méthode pour trouver des clients.
            C’est l’architecture complète d’un parcours de dix séances : quoi
            faire en séance 1, en séance 4 et en séance 10, et pourquoi.
          </p>

          <dl className="mt-10 grid grid-cols-2 gap-x-8 gap-y-6 border-t border-warm-line pt-8 sm:grid-cols-4" data-id="element-205" data-mp="1orueoii1w8d6">
            {revealStats.map(stat => <div key={stat.label} data-id="element-206" data-mp="w359o8dvjiw5">
                <dt className="font-serif text-2xl font-semibold text-graphite" data-id="element-207" data-mp="w46v96sinns4">
                  {stat.figure}
                </dt>
                <dd className="mt-1 text-xs leading-relaxed text-warm" data-id="element-208" data-mp="11549x9ebhzov">
                  {stat.label}
                </dd>
              </div>)}
          </dl>

          <ul className="mt-10 flex flex-wrap gap-x-2 gap-y-2" data-id="element-209" data-mp="2choo0q35veso">
            {coverageChips.map(chip => <li key={chip} className="rounded-sm border border-warm-line px-3 py-1.5 text-xs text-graphite-mid" data-id="element-210" data-mp="2hj4b0nowfvdp">
                {chip}
              </li>)}
          </ul>
        </div>

        <div className="lg:col-span-6" data-id="element-211" data-mp="21rlavzgbiduk">
          <div className="border border-warm-line bg-white p-8 shadow-paper md:p-10" data-id="element-212" data-mp="21qabebtwns99">
            <div className="flex items-start gap-3" data-id="element-213" data-mp="1wta11oq0w3cc">
              <YouAreHereDot className="mt-2" data-id="element-214" data-mp="1924nxhbgvp5q" />
              <p className="max-w-prose text-base leading-relaxed text-graphite" data-id="element-215" data-mp="192w8lx3j02h8">
                Dans un centre commercial, le plan n’est utile que grâce au
                point rouge : « Vous êtes ici ». Beaucoup d’accompagnements
                fonctionnent sans ce point. La méthode CAP™ le remet sur la
                carte.
              </p>
            </div>

            <ol className="mt-10 divide-y divide-warm-line border-t border-warm-line" data-id="element-216" data-mp="qb3hk880orc5">
              {capSteps.map(step => <li key={step.letter} className="flex gap-6 py-6" data-id="element-217" data-mp="lcac932vw6n2">
                  <span className="font-serif text-2xl font-semibold leading-none text-warm-light" data-id="element-218" data-mp="2wzvo12mpozik">
                    {step.letter}
                  </span>
                  <p className="text-base leading-relaxed text-graphite-mid" data-id="element-219" data-mp="31sov3x5nkjxt">
                    <span className="font-semibold text-graphite" data-id="element-220" data-mp="2n3sp05n5pgzu">
                      {step.title}
                    </span>{' '}
                    — {step.body}
                  </p>
                </li>)}
            </ol>

            <p className="mt-8 border-t border-warm-line pt-8 font-serif text-xl italic leading-relaxed text-graphite" data-id="element-221" data-mp="3kphmfnv9fapi">
              Le client ne continue pas parce qu’on le retient. Il continue
              parce qu’il voit qu’il avance.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}